import {
  createContext,
  useContext,
  type ReactElement,
  type ReactNode,
} from 'react';

interface ReportContextValue {
  eventMode?: string;
  metadata?: Record<string, unknown>;
  summary?: unknown;
  participationDetails?: unknown;
  gradewiseData?: unknown;
  fullReportData?: unknown;
}

const ReportContext = createContext<ReportContextValue | null>(null);

export const useReport = (): ReportContextValue => {
  const context = useContext(ReportContext);
  if (!context) {
    throw new Error('useReport must be used within a ReportProvider');
  }
  return context;
};

interface ReportProviderProps {
  children: ReactNode;
  reportData: {
    metadata?: { event_mode?: string; [key: string]: unknown };
    summary?: unknown;
    participation_details?: unknown[];
    gradewise_data?: unknown;
  };
}

export const ReportProvider = ({
  children,
  reportData,
}: ReportProviderProps): ReactElement => {
  const value: ReportContextValue = {
    eventMode: reportData?.metadata?.event_mode,
    metadata: reportData?.metadata,
    summary: reportData?.summary,
    participationDetails: reportData?.participation_details?.[0],
    gradewiseData: reportData?.gradewise_data,
    fullReportData: reportData,
  };

  return (
    <ReportContext.Provider value={value}>{children}</ReportContext.Provider>
  );
};
